import { ScheduleItem } from '../interfaces/schedules-suggestions';

type UpdateAppointmentCardFuncton = (groupId: number, selectedList: ScheduleItem[]) => void;

class AppointmentContext {
  static callUpdateAppointmentCard: UpdateAppointmentCardFuncton;
}

export default AppointmentContext;